import type { ReactNode } from "react";

const tones = {
  neutral: "bg-canvas text-muted border-line",
  brand: "bg-brand-soft text-brand border-brand/20",
  ok: "bg-ok/10 text-ok border-ok/20",
  danger: "bg-danger/10 text-danger border-danger/20",
  warn: "bg-warn/10 text-warn border-warn/20",
} as const;

export function Badge({ children, tone = "neutral" }: { children: ReactNode; tone?: keyof typeof tones }) {
  return <span className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium ${tones[tone]}`}>{children}</span>;
}

export function StatusBadge({ status }: { status: "open" | "won" | "lost" }) {
  return <Badge tone={status === "won" ? "ok" : status === "lost" ? "danger" : "brand"}>{status === "open" ? "Open" : status === "won" ? "Won" : "Lost"}</Badge>;
}
